import 'babel-polyfill';
import './common';
import '../l10n/guest/bg_BG';
import App from '../guest';

export default App;


